import { useEffect, useState } from 'react'
import Spinner from 'react-spinkit'
import EntidadeItem2 from '../../components/EntidadeItem2'
import { Entidade } from '../../model/Entidade'
import { Query } from '../../model/Query'
import { useProvider } from '../../provider/Provider'
import EntidadeService from '../../services/EntidadeService'
import { Container } from './style'

const initialFilters: Query = {
    limit: 6,
    page: 1,
    search: '',
    area: '',
    city: '',
    type: '',
    admin: true
}

const MinhasEmpresas = () => {
    const { authenticated } = useProvider()
    const [isLoading, setIsLoading] = useState(true)
    const [entidades, setEntidades] = useState<Entidade[]>([])
    const [total, setTotal] = useState<number>(0)

    useEffect(() => {
        if (authenticated) getMyEntities(initialFilters)
    }, [authenticated])

    const getMyEntities = async (query: Query) => {
        EntidadeService
            .get(query)
            .then((data) => {
                setEntidades(data.items)
                setTotal(data.total)
            })
            .finally(() => {setIsLoading(false)})
    }

    const getItems = () => {
        if (entidades.length === 0) {
            return (
                <p className="center">
                    Você ainda não cadastrou nenhuma empresa
                </p>
            )
        }
        return entidades.map((ent) => {
            return (
                <EntidadeItem2 ent={ent} key={ent.id} />
            )
        })
    }

    const getMore = () => {
        setIsLoading(true)
        getMyEntities({
            ...initialFilters,
            limit: initialFilters.limit + 6
        })
    }

    function hasMoreItems() {
        return entidades.length < total
    }

    return (
        <Container>
            <div>
                <h3 className="center">Minhas Empresas</h3>
                <div className="content center">
                    {!isLoading ? getItems() : false}
                    <div
                        className={
                            `${isLoading ? 'spinner-box' : 'hidden'}`
                        }
                    >
                        <Spinner
                            name="ball-clip-rotate-multiple"
                            color="#1A3549"
                            fadeIn="none"
                        />
                        <span>Buscando...</span>
                    </div>
                </div>
            </div>
            {
                hasMoreItems() && !isLoading
                    ? (
                        <div className="mais">
                            <div onClick={getMore}>Mostrar mais</div>
                        </div>
                    ) : false
            }
        </Container>
    )
}

export default MinhasEmpresas
